import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { USER_TYPE_SALES_OPPORTUNITY_PRIORITY } from '../../../public/types/user-type-sales-opportunity-priority.const';
import { UserOnboardingService } from '../../../public/user-onboarding/user-onboarding.service';
import { EDIT_PROFILE_MODAL_TYPE } from '../../types/edit-profile-modal-types.enum';
import { User } from '../../types/user.model';
import { AddCausesModalComponent } from '../add-causes-modal/add-causes-modal.component';
import { AddOrgTypesModalComponent } from '../add-org-types-modal/add-org-types-modal.component';
import { AddPrimaryIndustriesModalComponent } from '../add-primary-industries-modal/add-primary-industries-modal.component';

@Component({
  selector: 'mmb-web-app-step-interest',
  templateUrl: './step-interest.component.html',
  styleUrls: ['./step-interest.component.scss']
})
export class StepInterestComponent implements OnInit {
  @Input() user: User;
  selectedIndustries: any[];
  orgTypeInterests: any[] = [];
  scoringLevels = USER_TYPE_SALES_OPPORTUNITY_PRIORITY;

  constructor(private userOnboardingService: UserOnboardingService,
    private modalService: NgbModal, private route: ActivatedRoute) { }

  ngOnInit() {
    this._getUserIndustries();
    this._getUserOrgTypeInterests();
  }

  openIndustriesModal() {
    const modalRef = this.modalService.open(AddPrimaryIndustriesModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      this._getUserIndustries();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  openOrgTypesModal() {
    const modalRef = this.modalService.open(AddOrgTypesModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      this._getUserOrgTypeInterests();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  sortCausesByValue(causes) {
    return causes.sort((a, b) => (a.cause.value > b.cause.value) ? 1 : -1);
  }

  openCausesModal() {
    const modalRef = this.modalService.open(AddCausesModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  getProgressBarPercent(value: number) {
    let percent = this.getItemScore(value) * 100 / this.scoringLevels.length;
    return `${percent}%`;
  }

  getItemScore(value) {
    return this.scoringLevels.length - value + 1; // plus 1 as index is 1 based and not zero
  }

  private _getUserIndustries() {
    this.userOnboardingService.getUserPrimaryIndustry().subscribe((response) => {
      this.selectedIndustries = response;
    });
  }

  private _getUserOrgTypeInterests() {
    this.orgTypeInterests = [];
    this.userOnboardingService.getUserOrgTypeInterests().subscribe((response) => {
      for (let item of response) {
        this.orgTypeInterests.push({
          orgType: item.organisation_type,
          level: item.level,
          uuid: item.uuid
        });
      }
    });
  }
}
